import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../redux/actions/index';
import CardInfo from 'components/common/Cards/CardInfo';
import SpinnerLoading from 'components/Loading/SpinnerLoading';
import { Box, Button, HStack } from '@chakra-ui/react';
import PositionByDepartmentLists from './components/PositionByDepartmentLists';
import _ from 'lodash';

const driverReserveDepartmentId = 'f7d12253-5132-4351-9f32-a26da5f9ac16';
export default function DetailDepartment() {
    const history = useHistory();
    const { id } = useParams();
    const department = useSelector((state) => state.department);
    const position = useSelector((state) => state.position);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actions.departmentGet(id)).then((res) => {
            dispatch(actions.positionAllByDepartment(id)).then(() => {
                setIsLoading(true);
            });
        });
        return () => {};
    }, []);
    const onDelete = () => {
        dispatch(actions.departmentDelete(id)).then(() => {
            console.log('ลบแผนกสำเร็จ กำลังลบตำแหน่ง');
            dispatch(actions.positionDeleteByDepartment(id)).then(() => {
                console.log('ลบตำแหน่งสำเร็จ');
                history.push('/hrms/department');
            });
        });
    };
    // console.log(isLoading);
    return isLoading ? (
        <div>
            <h2 className="text-gray-800 text-xl font-semibold py-1">
                {' '}
                รายละเอียดแผนก
            </h2>

            <div className="flex py-6 justify-between">
                <div>
                    <Link to="/hrms/department">
                        <Button variant="outline">กลับ</Button>
                    </Link>
                </div>
                <div>
                    <HStack spacing={2}>
                        <Box>
                            <Link
                                to={
                                    '/hrms/department/edit/' +
                                    department.department_id
                                }
                            >
                                {' '}
                                <Button colorScheme="yellow">แก้ไข</Button>
                            </Link>
                        </Box>

                        <Button
                            colorScheme="red"
                            onClick={() => {
                                const confirm = window.confirm(
                                    'ยืนยันการลบข้อมูลแผนก'
                                );
                                if (confirm) onDelete();
                            }}
                            disabled={id === driverReserveDepartmentId}
                        >
                            ลบ
                        </Button>
                    </HStack>
                </div>
            </div>

            <div className="p-4">
                {/* <div className="flex content-center items-center justify-center h-full"> */}
                <div className="w-full lg:w-6/12 ">
                    <CardInfo
                        title={department.department_name}
                        subtitle={department.department_detail}
                        icon="fa fa-building"
                    />
                </div>
                <div className="my-6 ">
                    <div className="my-4">
                        <Link to={`/hrms/department/${id}/position/create`}>
                            <Button colorScheme="blue">เพิ่มตำแหน่ง</Button>
                        </Link>
                    </div>
                    <div className="shadow-lg">
                        {_.size(position) ? (
                            <PositionByDepartmentLists position={position} />
                        ) : (
                            <div className="flex content-center items-center justify-center  rounded rounded-t-lg bg-white p-4">
                                ไม่มีข้อมูลและรายละเอียดตำแหน่งในแผนก
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <SpinnerLoading />
    );
}
